export const SET_STATISTICS_DATA = "SET_STATISTICS_DATA"
export const SET_SELECTED_STATISTICS_MODEL = "SET_SELECTED_STATISTICS_MODEL"
export const CLEAR_STATISTICS_DATA = "CLEAR_STATISTICS_DATA"